import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'
import * as display from '../feature'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** TODO: Explain what is this */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'referenceRecords',
      parent: display.FEATURE,
      selectors: () => new Selectors(this),
    })

    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(
      effects.loadRecordsOnRequest(meFeature),
      effects.loadRecordsOnSubmit(),
      effects.submitRecordsOnRequest(meFeature),
    )
  }
}
